module.exports = __webpack_public_path__ + "static/media/max-GERS.6cfe0b20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/max-GERS.jpg
// module id = 1098
// module chunks = 0